const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class OnBoardingController {
    constructor(dialogRegistry, settings, analyticsService, onBoardingService) {
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.onBoardingService = onBoardingService;
        this.screenName = 'On Boarding';
    }

    $onInit() {
        const builder = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withEventType(this.analyticsService.mapperTypes.shop.onBoardingDialog)
            .withTrackingType('link')
            .build();
        this.analyticsService.push(builder);

        this.subscribeEscPushAnalytics();
    }

    dismissOnBoarding() {
        // push to tealium
        const builder = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Button/link click')
            .withValue('Next')
            .withEventType(this.analyticsService.mapperTypes.shop.onBoardingDialog)
            .withEventName('modal_interaction')
            .withTrackingType('link')
            .build();
        this.analyticsService.push(builder);

        this.onBoardingService.setOnboardingPreference(true);

        if (this.onDismiss) {
            this.onDismiss();
        }

        const dialog = this.dialogRegistry.getDialog('onBoarding dialog');
        if (dialog) {
            dialog.close();
        }
    }

    subscribeEscPushAnalytics() {
        this.unsubscribeEsc();

        $(document).on('keyup', (evt) => {
            if (evt.keyCode === 27) {
                // push to tealium
                this.analyticsService.push(new TealiumEventBuilder()
                    .withScreenName(this.screenName)
                    .withLabel('ESC Button')
                    .withEventName('modal_interaction')
                    .withEventType(this.analyticsService.mapperTypes.shop.onBoardingDialog)
                    .build());
            }
        });
        this.currentlySubscribedToEsc = this.screenName;
    }

    unsubscribeEsc() {
        if (this.currentlySubscribedToEsc === this.screenName) $(document).off('keyup');
    }
}

const onBoardingComponentDefinition = {
    bindings: {
        onDismiss: '&',
    },
    controller: ['DialogRegistry', 'Settings', 'AnalyticsService', 'OnBoardingService', OnBoardingController],
    template: require('./onboarding-dialog.component.html').trim(),
};

module.exports = {
    OnBoardingController,
    onBoardingComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/onboarding/onboarding-dialog.component.js